import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { AuthProvider } from '../src/hook/Auth'
import { UserProvider } from '../src/hook/useUsers'
import { BsmProjectProvider } from './hook/useBsm'
import { CompanyProvider } from './hook/useCompany'

ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <UserProvider>
        <BsmProjectProvider>
          <CompanyProvider>
            <App />
          </CompanyProvider>
        </BsmProjectProvider>
      </UserProvider>
    </AuthProvider>
  </Provider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
